import { createSelector } from "reselect"
import { get, first, last, chain } from "lodash"
import { getStartDate, getEndDate } from "modules/security-profile/selectors/dates"
import { createIntradaySelector } from "modules/security-profile/selectors/intraday"
import { toIsoDate } from "helpers/dates"
import { COLORS } from "helpers/analyzeConstants"

export const CATEGORIES = [{ id: "dailyForecast", label: "Daily Forecast", color: COLORS[0] }]
export const FACTORS = {
  expectedReturn: {
    category: "dailyForecast",
    label: "Expected Return",
  },
}

export const getForecastId = state => get(state, "modules.securityProfile.displayType.id")
const getForecastData = createIntradaySelector(
  "global.data.securityProfileForecast.data.model.simulation.dailyForecast",
  "global.data.securityProfileForecast.data.model.intradaySimulation.forecast",
)

function formatForecast(forecast) {
  const count = forecast.length
  return chain(forecast)
    .map(({ date, expectedReturn, horizon }, index) => {
      if (expectedReturn != null || index === count - 1) {
        return ({
          date,
          factors: {
            expectedReturn: expectedReturn / 100,
            horizon,
          },
        })
      }
      return null
    })
    .filter(data => data)
    .value()
}

export const getForecast = createSelector(
  [getForecastData],
  (absolute) => formatForecast(absolute || {}),
)

export const getFilteredForecast = createSelector(
  [getForecast, getStartDate, getEndDate],
  (forecast, startDate, endDate) =>
    forecast.filter((data) => {
      const date = toIsoDate(data.date)
      return date >= startDate && date <= endDate
    }),
)

export const getFirst = createSelector(
  [getForecast],
  (forecast) => first(forecast),
)

export const getCurrent = createSelector(
  [getForecast],
  (forecast) => last(forecast),
)

export const getFirstForecastDate = createSelector(
  [getFilteredForecast],
  (forecast) => toIsoDate(get(first(forecast), "date", null)),
)
